module.exports = __webpack_public_path__ + "static/media/witches-hat.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/default/witches-hat.svg
// module id = 56
// module chunks = 0